module.exports = __WEBPACK_EXTERNAL_MODULE__ontotext_workbench_api_028e80c2__;